export enum POIFuelingPriceGroup {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM' ,
  HIGH = 'HIGH'
}
